const ScreenSizes = {
    Mobile: 1020
};
export default ScreenSizes;